import { render, staticRenderFns } from "./washing-machine.vue?vue&type=template&id=8b03ea06&scoped=true"
import script from "./washing-machine.vue?vue&type=script&lang=js"
export * from "./washing-machine.vue?vue&type=script&lang=js"
import style0 from "./washing-machine.vue?vue&type=style&index=0&id=8b03ea06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b03ea06",
  null
  
)

export default component.exports